import { isLocalDev } from '../platform/environment';
import { defaultTenantConfig, defaultConfig } from './config.default';

// const isInGrey = checkTranslateFG(FeatureGateKeys.MEEGO_PLATFORM_CHANGE_DOMAIN);
// const isInGrey = true;
// const host = isInGrey ? 'https://meego.larkofficeboe.com' : 'https://meego.feishu-boe.cn';
const host = 'https://meego.feishu-boe.cn';

const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,

  region: 'boe',
  avatarDomain: `${host}/goapi`,
  host: isLocalDev ? '' : host,
  hostForGo: isLocalDev ? '/goapi' : `${host}/goapi`,
  collectHost: 'https://dahdpa2y.fn-boe.bytedance.net',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnhGBz5VDr5xFsGV9bGgcpwe',
  currentHost: host,
  tosBucket: 'meego',
  bytereplayEnv: 'BOE',
  larkLoginHost: host.replace('meego', 'www'),
  // larkLoginHost: 'https://www.feishu-boe.cn',
  tenantConfig: defaultTenantConfig,
  labProjectId: '62217bfa6e5c01f61d1915fb',
  labViewId: '6t8fncLnR',
  showTenantIds: '6965313173725380627',
  helpcenterUrl: `${host}/helpcenter/home`,
  internalApi: host.replace('https://meego', 'internal-api-lark-api'),
}))();

export default config;
